// extracted by mini-css-extract-plugin
export var filtersTaxo = "listResults-module--filters-taxo--7c6e9";
export var listResult = "listResults-module--list-result--8a36a";
export var resultContent = "listResults-module--result-content--29e40";
export var resultItem = "listResults-module--result-item--79f14";
export var resultMore = "listResults-module--result-more--b5923";
export var resultResume = "listResults-module--result-resume--c6ede";
export var resultTitle = "listResults-module--result-title--18318";
export var resultType = "listResults-module--result-type--ae8a1";
export var resultTypeIcon = "listResults-module--result-type-icon--c2a1f";
export var resultTypeType = "listResults-module--result-type-type--58828";
export var results = "listResults-module--results--1578b";
export var resultsContainer = "listResults-module--results-container--0b01d";
export var resultsTop = "listResults-module--results-top--f8c66";